import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import CreatePromptButton from "./CreatePromptButton";
import DirectPromptGenerator from "./DirectPromptGenerator";
import PromptsList from "./PromptsList";
import TranscriptsList from "./TranscriptsList";

interface PromptEngineContentProps {
  onTabChange?: (tab: string) => void;
  hideButtons?: boolean;
}

export default function PromptEngineContent({ onTabChange, hideButtons = false }: PromptEngineContentProps) {
  const [activeTab, setActiveTab] = useState("prompts");
  const [showDirectGenerator, setShowDirectGenerator] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <Tabs
          defaultValue="prompts"
          className="w-full"
          onValueChange={(value) => {
            setActiveTab(value);
            // Reset direct generator view when switching tabs
            if (value !== activeTab) {
              setShowDirectGenerator(false);
            }
            // Notify parent about tab change
            if (onTabChange) {
              onTabChange(value);
            }
          }}
          value={activeTab}
        >
          <TabsList>
            <TabsTrigger value="prompts">Prompts</TabsTrigger>
            <TabsTrigger value="transcripts">Transcripts</TabsTrigger>
            <TabsTrigger value="direct">Direct Generation</TabsTrigger>
          </TabsList>
          {!hideButtons && (
            <div className="flex justify-end mt-2">
              {activeTab !== "direct" && (
                <CreatePromptButton activeTab={activeTab} />
              )}
            </div>
          )}
          <TabsContent value="prompts" className="mt-6">
            <PromptsList />
          </TabsContent>
          <TabsContent value="transcripts" className="mt-6">
            <div className="mb-6">
              <h2 className="text-2xl font-bold">Transcripts</h2>
              <p className="text-md text-muted-foreground mt-1">
                Manage and view your conversation transcripts.
              </p>
            </div>
            <TranscriptsList />
          </TabsContent>
          <TabsContent value="direct" className="mt-6">
            <Card>
              <CardContent className="pt-6">
                <DirectPromptGenerator />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
